import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const endOfDayForm = {
  id: 'end-of-day-form',

  getDocumentRequestNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingEndOfDayFormTitle} values={{ docCount }} />,
  }),
};
